import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { ApiResponse } from '@core/types';
import { Bank, BankCreate, BankUpdate } from '@core/types/finance.type';

@Injectable({ providedIn: 'root' })
export class BankService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.api}/finance/banks`;

  getBanks(): Observable<ApiResponse<Bank[]>> {
    return this.http.get<ApiResponse<Bank[]>>(this.apiUrl);
  }

  getBank(id: string): Observable<ApiResponse<Bank>> {
    return this.http.get<ApiResponse<Bank>>(`${this.apiUrl}/${id}`);
  }

  createBank(data: BankCreate): Observable<ApiResponse<string>> {
    return this.http.post<ApiResponse<string>>(this.apiUrl, data);
  }

  updateBank(data: BankUpdate): Observable<ApiResponse<void>> {
    return this.http.put<ApiResponse<void>>(this.apiUrl, data);
  }

  deleteBank(id: string): Observable<ApiResponse<void>> {
    return this.http.delete<ApiResponse<void>>(`${this.apiUrl}/${id}`);
  }
}
